import {
  globalConstants,
  globalSystemConstants,
  eventConstants,
} from "../../constants";

const {
  ADMIN_EVENT_LIST,
  ALL_EVENT,
  VIEW_MODAL,
  EVENT_DATA_BY_ID,
  EVENT_DATA_BY_ID_WITH_DOCS,
  ADMIN_EVENT_PARTICIPANTS_LIST,
  SEARCH_PARTICIPANTS,
  LIST_PUBLIC_EVENTS,
  MY_EVENTS_LIST,
  VALIDATE_PARTICIPANTS,
  VALIDATE_PARTICIPANTS_TOFALSE,
  RESET_PARTICIPANT_DETAILS,
  RESET_EVENT_DATA_BY_ID,
  EVENT_TOTAL_PAYMENT_BY_ID_DATA,
} = eventConstants;

const initialState = {
  eventData: null,
  eventParticipantsData: null,
  openModal: false,
  eventDataById: null,
  eventDataByIdWithDocs: null,
  openAppRejModal: false,
  allEvents: [],
  participant_details: null,
  publicEvents: null,
  myEvents: null,
  isParticipantsValidated: false,
  eventTotalPaymentById: null,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_EVENT_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        eventData: action.data,
      };
    case LIST_PUBLIC_EVENTS + globalConstants.SUCCESS:
      return {
        ...state,
        publicEvents: action.data,
      };
    case MY_EVENTS_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        myEvents: action.data,
      };
    case ADMIN_EVENT_PARTICIPANTS_LIST + globalConstants.SUCCESS:
      return {
        ...state,
        eventParticipantsData: action.data,
      };
    case RESET_PARTICIPANT_DETAILS + globalConstants.SUCCESS:
      return {
        ...state,
        participant_details: null,
      };
    case ALL_EVENT + globalConstants.SUCCESS:
      return {
        ...state,
        allEvents: action.data,
      };
    case SEARCH_PARTICIPANTS + globalConstants.SUCCESS:
      return {
        ...state,
        participant_details: action.data,
      };
    case VIEW_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        openModal: action.data,
      };
    case EVENT_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        eventDataById: action.data,
      };
    case RESET_EVENT_DATA_BY_ID:
      return {
        ...state,
        eventDataById: null,
      };
    case EVENT_DATA_BY_ID_WITH_DOCS + globalConstants.SUCCESS:
      return {
        ...state,
        eventDataByIdWithDocs: action.data,
      };
    case globalSystemConstants.SPINNER_ACTIVATE:
      return {
        ...state,
        spinnerActions: true,
      };
    case globalSystemConstants.SPINNER_DEACTIVATE:
      return {
        ...state,
        spinnerActions: false,
      };
    case VALIDATE_PARTICIPANTS + globalConstants.SUCCESS:
      return {
        ...state,
        isParticipantsValidated: true,
      };
    case VALIDATE_PARTICIPANTS_TOFALSE:
      return {
        ...state,
        isParticipantsValidated: false,
      };
    case EVENT_TOTAL_PAYMENT_BY_ID_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        eventTotalPaymentById: action.data,
      };
    default:
      return state;
  }
};

export default eventReducer;
